export const numberFilterOptions = [
  { label: 'Equals', value: 'equals' },
  { label: 'Not equal', value: 'notEqual' },
  { label: 'Less than', value: 'lessThan' },
  { label: 'Less than or equals', value: 'lessThanOrEqual' },
  { label: 'Greater than', value: 'greaterThan' },
  { label: 'Greater than or equals', value: 'greaterThanOrEqual' },
  { label: 'In range', value: 'inRange' },
];

export const textFilterOptions = [
  { label: 'Equals', value: 'equals' },
  { label: 'Not equal', value: 'notEqual' },
  { label: 'Contains', value: 'contains' },
  { label: 'Not contains', value: 'notContains' },
  { label: 'Starts with', value: 'startsWith' },
  { label: 'Ends with', value: 'endsWith' },
];
